import { forwardRef } from "react";
import { getLinkComponent } from "../../lib/config";

const Link = forwardRef(function Link(props: any, ref) {
  const Component = getLinkComponent();
  return <Component {...props} ref={ref} />;
});
export default Link;
